import React from "react";
import styled from "styled-components";
import {faChevronLeft, faChevronRight} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin-top: 50px;
`;

const PageBtn = styled.button`
    padding: 8px 10px;
    background-color: ${({isActive}) => (isActive ? "#f5ab18" : "#fff")};;
    color: ${({isActive}) => (isActive ? "#fff" : "#554e47")};
    border-radius: 5px;
    border: ${({isActive}) => (isActive ? "1px solid #f5ab18" : "1px solid #e3e3e3")};
    cursor: pointer;
    transition: background-color 0.2s ease;
    font-size: 14px;
    font-weight: ${({isActive}) => (isActive ? "700" : "500")};

`;
const ArrowBtn = styled(FontAwesomeIcon)`
    font-size: 14px;
    margin: 0 8px;
    color: #f5ab18;
    cursor: pointer;
    border: 1px solid #f5ab18;
    padding: 8px 10px;
    border-radius: 5px;
`;
const Pagination = ({page, totalPages, changePage}) => {
    return (
        <Wrapper>
            <ArrowBtn
                icon={faChevronLeft}
                onClick={() => changePage(page === 1 ? 1 : page - 1)}
            />
            {Array.from({length: totalPages}, (_, i) => (
                <PageBtn
                    key={i}
                    isActive={page === i + 1}
                    onClick={() => changePage(i + 1)}
                >
                    {i + 1}
                </PageBtn>
            ))}
            <ArrowBtn
                icon={faChevronRight}
                onClick={() =>
                    changePage(page === totalPages ? totalPages : page + 1)
                }
            />
        </Wrapper>
    )
        ;
};

export default Pagination;
